var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTrackSeparationTab = function SvgTrackSeparationTab(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m18.334 7.335 2.363-2.301a1.258 1.258 0 0 0 0-1.815L18.377.918M18.477 21.14l2.283-2.268a1.282 1.282 0 0 0 0-1.823l-2.24-2.268",
    stroke: "currentColor",
    strokeWidth: 1.875,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M.86 11h3.662c1.495-.005 2.915-.627 3.894-1.757l2.926-3.374a5.18 5.18 0 0 1 3.913-1.787h5.284M8.793 13.234l2.549 2.94a5.179 5.179 0 0 0 3.913 1.787h5.284",
    stroke: "currentColor",
    strokeWidth: 1.875,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgTrackSeparationTab;